module.exports = __webpack_public_path__ + "img/qinzhou.ac61007e.png";